import React from 'react';
import { VStack, Text, SimpleGrid, Box, Icon, Flex, Image } from '@chakra-ui/react';
import {
  SFCircleDottedCircleIcon,
  SFLineChartIcon,
  InsightIcon,
  SFBookPagesOutlinedIcon
} from '@assets/icons';
import { ForaLogoWhite } from '@assets/images';

// Component can be used in both mobile and desktop layouts
const ChatSplashScreen = () => {
  const features = [
    {
      icon: SFCircleDottedCircleIcon,
      title: 'Strategic Analysis',
      description: 'Review the strategic topics relevant to your org.'
    },
    {
      icon: SFLineChartIcon,
      title: 'Sentiment Analysis',
      description: 'Understand the sentiment regarding topics & people.'
    },
    {
      icon: InsightIcon,
      title: 'Topic Deep-Dive',
      description: 'Dig deeper into an individual topic that was discussed.'
    },
    {
      icon: SFBookPagesOutlinedIcon,
      title: 'Transcript Deep-Dive',
      description: 'Review key quotes, debates, and other info.'
    }
  ];

  return (
    <VStack
      spacing={6}
      align='center'
      px={6}
      py={8}
      h='100%'
      maxH='calc(100vh - 140px)' // Account for header and input
      overflow='auto'
      style={{ scrollbarWidth: 'none' }}
    >
      {/* FORA Logo */}
      <Box
        bg='brandPrimary.primary'
        borderRadius='xl'
        p={2}
        width='64px'
        height='64px'
        display='flex'
        alignItems='center'
        justifyContent='center'
        flexShrink={0}
      >
        <Image
          h='78px'
          w='78px'
          src={ForaLogoWhite}
        />
      </Box>

      {/* Title Section */}
      <VStack
        spacing={2}
        flexShrink={0}
      >
        <Text
          fontSize='xl'
          fontWeight='semibold'
          textAlign='center'
        >
          What would you like to know about this meeting?
        </Text>
        <Text
          color='light_material.600'
          fontSize='sm'
          textAlign='center'
        >
          Here are some ways that you can leverage FORA:
        </Text>
      </VStack>

      {/* Feature Grid - Now using SimpleGrid with minChildWidth */}
      <SimpleGrid
        columns={{ base: 1 }}
        spacing={2}
        w='100%'
        maxW='600px'
        borderRadius='lg'
      >
        {features.map((feature) => (
          <FeatureCard
            key={feature.title}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </SimpleGrid>
    </VStack>
  );
};

const FeatureCard = ({ icon, title, description }) => (
  <Box
    bg='surface.surface'
    p={4}
    borderRadius='lg'
    // commenting out cursor / hover functionality til they actually work
    // cursor="pointer"
    // _hover={{ bg: 'blue.100' }}
    transition='background 0.2s'
    height='100%'
  >
    <Flex gap={3}>
      <Icon
        as={icon}
        boxSize={5}
        color='brandPrimary.primary'
        flexShrink={0}
      />
      <VStack
        align='start'
        spacing={1}
      >
        <Text
          color='brandPrimary.onPrimaryFixed'
          fontWeight='medium'
          fontSize='md'
        >
          {title}
        </Text>
        <Text
          fontSize='sm'
          color='surface.onSurfaceVariant'
          lineHeight='short'
        >
          {description}
        </Text>
      </VStack>
    </Flex>
  </Box>
);

export default ChatSplashScreen;
